import Vue from 'vue'
import I18n from 'vue-i18n'
import en from './en'
import es from './es'

const messages = {
  en,
  es
}

Vue.use(I18n)

export default new I18n({
  locale: sessionStorage.getItem('language') || process.env.VUE_APP_LANG_DEFAULT, // set default locale
  messages
})

// Hot updates
if (module.hot) {
  module.hot.accept(['./en', './es'], function () {
    I18n.setLocaleMessage('en', require('./en').default)
    I18n.setLocaleMessage('es', require('./es').default)
  })
}
